import type { MediaRef, MediaType, LibraryCollection } from '../types';
import { COLLECTIONS_CONFIG } from '../constants/collections';

import { CollectionIcon } from './CollectionIcon';

import styles from './LibraryActions.module.css';

interface LibraryActionsProps {
  itemId: number;
  mediaType: MediaType;
  variant?: 'card' | 'modal';
  currentCollection?: LibraryCollection;
  updateCollection: (ref: MediaRef, target: LibraryCollection) => void;
}

export function LibraryActions({ itemId, mediaType, variant = 'card', currentCollection, updateCollection }: LibraryActionsProps) {
  const handleAction = (e: React.MouseEvent, target: LibraryCollection) => {
    e.stopPropagation();
    const nextCollection = currentCollection === target ? null : target;
    updateCollection({ id: itemId, media_type: mediaType }, nextCollection as any);
  };

  return (
    <div className={`${styles.container} ${styles[variant]}`}>
      {Object.entries(COLLECTIONS_CONFIG).map(([key, config]) => {
        const collectionKey = key as LibraryCollection;
        const isActive = currentCollection === collectionKey;

        return (
          <button
            key={collectionKey}
            onClick={(e) => handleAction(e, collectionKey)}
            className={`${styles.actionBtn} ${isActive ? styles.active : ''}`}
            title={config.label}
          >
            <CollectionIcon name={collectionKey} />
            {variant === 'modal' && <span className={styles.label}>{config.label}</span>}
          </button>
        );
      })}
    </div>
  );
}